import {useState} from "react";
import {getColor} from "@/styles/ThemeConfig";
import {breakpoints} from "@/styles/sizes";
import styled, {css} from "styled-components";
import Image from "next/image";

import MinusWhiteIcon from '/public/images/minus_white.svg';
import PlusIcon from '/public/images/plus.svg';


const TitleWrapper = styled.div`
    color: ${getColor('gold')};
    text-transform: uppercase;
    @media only screen and (${breakpoints.mobile}) {
        padding: 0 10px;
    }
    margin-bottom: 10px;
`;


const FaqQuestion = styled.div`
    background: white;
    color: ${getColor('greenText')};
    font-family: 'Josefin Sans';
    font-size: 14px;
    letter-spacing: 1px;
    text-transform: uppercase;
    padding: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    
    ${props => props.isActive && css`
        background: ${getColor('gold')}!important;
        color: white;
    `}
`;

const FaqAnswer = styled.div`
    color: ${getColor('greenText')};
    max-height: 0;
    padding: 0;
    overflow: hidden;
    transition: 0.5s ease; /* Only apply transition to max-height */

    ${props => props.isActive && css`
        max-height: 500px; /* Set a large enough max-height */
    `}
    
    p {
        padding: 20px;
    }
`;



const ColumnWrapper = styled.div`
    display: flex;
    gap: 50px;
    @media only screen and (${breakpoints.mobile}) {
        flex-direction: column;
        padding: 10px;
        gap: 10px;
    }
`;
export default function TourFaqSection({
    title = 'Help Center',
    subtitle = 'Frequently Asked Questions',
    withMarginTop = true,
                                           faqs
})
{
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <div id={'FAQ'} style={{
            backgroundColor:getColor('grayBackground'),
            padding:'80px 0',
            marginTop:withMarginTop ? '80px' : '0',
        }}>
            <div className={'container'}>
                <TitleWrapper>
                    {title && <h2 className={'h4'}>{title}</h2>}
                    {subtitle && <h2 className={'h4'} style={{fontWeight: 'bold'}}>{subtitle}</h2>}
                </TitleWrapper>
                    <ColumnWrapper>
                        {/* First Column */}
                        <div style={{flex: 1, display: 'flex', flexDirection: 'column', gap: '10px'}}>
                            {faqs.slice(0, Math.ceil(faqs.length / 2)).map((faq, index) => (
                                <div key={index}>
                                    <FaqQuestion isActive={activeIndex === index} onClick={() => toggleFAQ(index)}>
                                        <p>{faq.question}</p>
                                        {activeIndex === index ?
                                            <Image src={MinusWhiteIcon} alt={'-'} />
                                            :
                                            <Image src={PlusIcon} alt={'+'} />
                                        }
                                    </FaqQuestion>
                                    <FaqAnswer isActive={activeIndex === index}><p dangerouslySetInnerHTML={{__html:faq.answer}}/></FaqAnswer>
                                </div>
                            ))}
                        </div>

                        {/* Second Column */}
                        <div style={{flex: 1, display: 'flex', flexDirection: 'column', gap: '10px'}}>
                            {faqs.slice(Math.ceil(faqs.length / 2)).map((faq, index) => (
                                <div key={index + Math.ceil(faqs.length / 2)}>
                                    <FaqQuestion isActive={activeIndex === index + Math.ceil(faqs.length / 2)}
                                                 onClick={() => toggleFAQ(index + Math.ceil(faqs.length / 2))}>
                                        <p>{faq.question}</p>
                                        {activeIndex === index + Math.ceil(faqs.length / 2) ? <Image src={MinusWhiteIcon} alt={'-'} />
                                            :
                                            <Image src={PlusIcon} alt={'+'} />}
                                    </FaqQuestion>
                                    <FaqAnswer
                                        isActive={activeIndex === index + Math.ceil(faqs.length / 2)}><p dangerouslySetInnerHTML={{__html:faq.answer}}/></FaqAnswer>
                                </div>
                            ))}
                        </div>
                    </ColumnWrapper>
            </div>
        </div>

    );
}
